<template>
  <div>
    <div class="w-100 p-2" dir="rtl" v-if="data['analysis']['graha_war']">
      <ul class="nav nav-tabs" id="myTab" role="tablist">

        <li class="nav-item" role="presentation">
          <button class="nav-link active " id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button"
            role="tab" aria-controls="home" aria-selected="true">
            اتصالات و نظرات
          </button>
        </li>

        <!-- <li class="nav-item" role="presentation">
          <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button"
            role="tab" aria-controls="contact" aria-selected="false">کاراکا</button>
        </li> -->
        <li class="nav-item" role="presentation" v-if="show_yogas == '1'">
          <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button"
            role="tab" aria-controls="profile" aria-selected="false">
            یوگاها
            <small>
              (آزمایشی)
            </small>
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
          <div class="row mt-3">
            <div class="col-12 col-lg-12">
              <span style="font-size: 14px;"><b>اتصالات</b></span>
              <span v-if="tagPairs" v-for="(pairs, tag) in tagPairs" :key="tag">

                <span>
                  <span class="badge bg-light text-dark border border-1 m-1" v-for="item in pairs">
                    {{ item }}
                    ⁓
                    <span>{{ tagMessages[tag] }}</span>
                  </span>
                </span>
                <!-- <td>{{ pairs.join(', ') }}</td> -->
              </span>

              <span class="table" v-else>
                هیچ اتصالی در این چارت وجود ندارد.
              </span>
            </div>
            <div class="col-12 col-lg-12 mt-3" dir="rtl">
              <hr />
              <span style="font-size: 14px;"><b>نظرات</b></span>
              <span v-for="(grahaData, graha) in data['analysis']['aspects']" :key="graha">


                <span v-if="grahaData" class="badge bg-light text-primary border border-1  m-1"
                  v-for="(value, key ) in grahaData['aspect']" :key="key">
                  <span>
                    {{ graha }}
                    (خانه {{ toPersian(grahaData['house']) }})
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-arrow-left" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                    </svg>
                    {{ key }}
                  </span>

                </span>


              </span>

            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab" v-if="show_yogas == '1'">

          <p>
          <table class="table" v-for="(yoga, index) in yogaResponses" :key="index">
            <tbody>
              <tr>
                <td>
                  <!-- {{ yoga }} -->
                  <ul v-if="yoga.result.msg" v-for="item in yoga.result.msg" :key="item">
                    <li>
                      {{ item }}
                    </li>
                  </ul>
                  <ul v-else>
                    <li>
                      هیچ یوگایی در این چارت وجود ندارد.
                    </li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          </p>

        </div>
        <!-- <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">

          <div class="row mt-4">
            <div class="col-6 mr-auto mx-auto text-center">
              <div class="d-flex align-items-end flex-column mb-3" style="height: 200px;">
                <div class="p-2 text-center ms-auto me-auto">
                  <img class="mb-3" :src="'https://www.horastro.co/wp-content/uploads/2022/08/' +
                    this.data.analysis.karakas.Atma.planet +
                    '.png'
                    " width="30" />
                  <h4>
                    {{ this.data.analysis.karakas.Atma.planet }}
                  </h4>
                  <h5>
                    {{ formatDegree(this.data.analysis.karakas.Atma.degree) }}
                  </h5>
                </div>
                <div class="p-2 ms-auto me-auto">
                  <h5>
                    AK
                  </h5>
                  <span class="badge bg-light text-success">
                    آتماکاراکا
                  </span>
                </div>
              </div>
            </div>
            <div class="col-6  mr-auto mx-auto text-center">
              <div class="d-flex align-items-end flex-column mb-3" style="height: 200px;">
                <div class="p-2 text-center ms-auto me-auto">
                  <img class="mb-3" :src="'https://www.horastro.co/wp-content/uploads/2022/08/' +
                    this.data.analysis.karakas.Amatya.planet +
                    '.png'
                    " width="30" />
                  <h4>
                    {{ this.data.analysis.karakas.Amatya.planet }}
                  </h4>
                  <h5>
                    {{ formatDegree(this.data.analysis.karakas.Amatya.degree) }}
                  </h5>
                </div>
                <div class="p-2 ms-auto me-auto">
                  <h5>
                    AmK
                  </h5>
                  <span class="badge bg-light text-primary">
                    آماتی‌ کاراکا
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>

import AnalysisMeta from "./analysis_meta"
import { capitalize } from './utils';
import HelperLib from "../components/helper";

export default {
  name: "ChartAnalysisPro",
  data() {
    return {
      grahaNames: {
        'Su': 'خورشید',
        'Mo': 'ماه',
        'Ma': 'مارس',
        'Me': 'مرکوری',
        'Ju': 'ژوپیتر',
        'Ve': 'ونوس',
        'Sa': 'سترن',
        'Ra': 'راهو',
        'Ke': 'کیتو'
      },
      tagMessages: {
        'EXACT': 'دقیق',
        'CLOSE': 'نزدیک',
        'WEAK': 'سست',
        'VIRTUAL': 'مجازی',
        'NORMAL': 'عادی'
      }
    }
  },
  props: {
    show_yogas: String,
    data: Object
  },
  components: {
  },
  mounted() {
    // console.log(meta);
  },
  computed: {
    yogaResponses() {
      const response = []
      for (const yoga in this.data['analysis']['yoga']) {
        if (yoga == 'parivartana') {
          for (const item in this.data['analysis']['yoga'][yoga]) {
            response.push({ name: yoga, result: { msg: [`در این چارت سیاره‌ی ${this.data['analysis']['yoga'][yoga][item][0]} و ${this.data['analysis']['yoga'][yoga][item][1]} دارای یوگای Partivartana هستند.`]} })
          }
        } else {
          for (const meta_item in AnalysisMeta) {
            if (yoga == meta_item && this.data['analysis']['yoga'][yoga] == true) {
              // console.log(AnalysisMeta[yoga])
              response.push({ name: yoga, result: AnalysisMeta[yoga] });
              // response.push(yoga, AnalysisMeta[yoga])
            }
          }
        }
      }

      return response;
    },
    tagPairs() {
      let tagPairs = {};
      for (const rashi in this.data['analysis']['graha_war']) {
        for (const pair of this.data['analysis']['graha_war'][rashi]) {
          const graha1Name = this.grahaNames[pair.graha1];
          const graha2Name = this.grahaNames[pair.graha2];
          if (!tagPairs[pair.tag]) {
            tagPairs[pair.tag] = [];
          }
          tagPairs[pair.tag].push(`${graha1Name} و ${graha2Name}`);
        }
      }
      return tagPairs;
    }
  },
  methods: {
    formatDegree(deg) {
      const out = HelperLib.convertDegreeToDMS(deg)
      return `${HelperLib.paddy(out['deg'], 2)}:${HelperLib.paddy(out['min'], 2)}`
    },
    dignityText(text) {
      if (text == 'neecha') {
        return "DB"
      }
      if (text == 'swa') {
        return "OH"
      }
      if (text == 'mool') {
        return "MT"
      }
      if (text == 'ucha') {
        return "EX"
      }
      if (text == 'friend') {
        return "F"
      }
      if (text == 'enemy') {
        return "E"
      }
      if (text == 'neutral') {
        return "N"
      }
    },
    toPersian(n) {
      let ones = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
      let tens = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
      let teens = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];

      if (n < 10) return ones[n];
      else if (n >= 10 && n < 20) return teens[n - 10];
      else {
        let unit = n % 10;
        let ten = Math.floor(n / 10);
        if (unit != 0) return tens[ten] + " و " + ones[unit];
        else return tens[ten];
      }
    },
    capitalizeText(text) {
      return capitalize(text)
    },
    addWarAnalysis() {
      let tagPairs = {};
      for (const rashi in this.data['analysis']['graha_war']) {
        for (const pair of this.data['analysis']['graha_war'][rashi]) {
          const graha1Name = this.grahaNames[pair.graha1];
          const graha2Name = this.grahaNames[pair.graha2];
          const tagMessage = this.tagMessages[pair.tag];
          if (!tagPairs[tagMessage]) {
            tagPairs[tagMessage] = [];
          }
          tagPairs[tagMessage].push(`${graha1Name} و ${graha2Name}`);
        }
      }
      let sentences = [];
      for (const tag in tagPairs) {
        sentences.push(tag + '<br/> 🔴 ' + tagPairs[tag].join('<br/> 🔴'));
      }
      return sentences.join('<br/>');
    }
  },
};
</script>
